import { Historical } from './../pages/historical/historical';
import { Component, ViewChild, Inject } from '@angular/core';
import {
	Platform,
	ToastController,
	AlertController,
	MenuController,
	NavController,
	App,
	ActionSheetController,
	Events
} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from '../pages/home/home';
import { Storage } from '@ionic/storage';
import { GestPoi } from '../pages/gestpoi/gestpoi';
import { Vehicules } from '../pages/datamana/vehicules/vehicules';
import { Groupes } from '../pages/datamana/groupes/groupes';
import { DriverComponent } from '../pages/datamana/chauffeurs/chauffeurs';

import { PathsList } from '../pages/paths-list/paths-list';

import { RealTimeService } from '../providers/real-time.service';
import { HistoricalForm } from '../pages/historical-form/historical-form';
import { Subscription } from 'rxjs';
import { RealTimeRecord, Group, Vehicule } from '../objects/real-time';
import { MapService } from '../utils/map.service';
import { InfoTrackerPage } from '../pages/info-tracker/info-tracker';
import { GeocodingService } from '../utils/geocoding.service';
import { timer } from 'rxjs/observable/timer';
import { version } from '../providers/global.config';
import { DashboardPage } from '../pages/dashboard/dashboard';
@Component({
	templateUrl: 'app.html'
})
export class MyApp {
	version: String = version;
	showLevel1 = null;
	showLevel2 = null;
	allGroups: Subscription;
	data: any[] = [];
	public groups: any[] = [];
	searchWord: string = '';
	hideMe = false;
	hideGroupi = false;
	visibleV = false;
	visibleG = false;
	engine = true;
	public shownGroup: any[] = [];
	numb: any;
	cluster: any;
	isCurrentPathClicked: boolean = false;
	searchTerm: string = '';
	optionsIsShown: boolean = false;
	isOpen: boolean = false;
	isSignIn: boolean = false;
	showSplash = true; // <-- show animation
	// pages : any;

	// integration du navController dans app.component.ts
	@ViewChild('mycontent') nav: NavController;
	rootPage;
	listhide: boolean = true;
	tempsreelopened: boolean = true;
	alert: any;
	expirer: boolean = false;

	constructor(
		private real: RealTimeService,
		public platform: Platform,
		statusBar: StatusBar,
		private _app: App,
		public actionSheetCtrl: ActionSheetController,
		private menuCtrl: MenuController,
		private alertCtrl: AlertController,
		private storage: Storage,
		splashScreen: SplashScreen,
		public toastCtrl: ToastController,
		private toastController: ToastController,
		public events: Events,
		public mapService: MapService,
		public geocodingService: GeocodingService
	) {
		platform.ready().then(() => {
			//alert de confirmation de quitter l'application
			platform.registerBackButtonAction(() => {
				if (this.nav.canGoBack()) {
					this.nav.pop();
				} else {
					if (this.alert) {
						this.alert.dismiss();
						this.alert = null;
					} else {
						this.showAlert();
					}
				}
			});
			//check previous signing
			this.checkPreviousAuthorization();
			console.log(this.isSignIn);
			splashScreen.hide();
			// statusBar.show();
			statusBar.styleDefault();
			timer(4000).subscribe(() => (this.showSplash = false)); // <-- hide animation after 4s
			//
		});

		//chargingGroupInfo()
		events.subscribe('chargingGroupInfo', () => {
			this.chargingGroupInfo();
		});
	}

	chargingGroupInfo() {
		this.allGroups = this.real.getAllGroups(this.searchWord).subscribe((groupes) => {
			this.groups = groupes;
			console.log('group', this.groups);
			//save list of group in other list for search purpose
			this.generateGroups();

			this.groups.forEach((group) => {
				group.vehicules.forEach((vehicule) => {
					// console.log(vehicule.idDevice);
					vehicule.realTimeRecord = new RealTimeRecord();

					this.real.getRealTimeRecord(vehicule.idDevice).subscribe(
						(x) => {
							vehicule.realTimeRecord = x;
							vehicule.realTimeRecord.vehicule = new RealTimeRecord();

							this.geocodingService
								.inverseGeoconding(
									vehicule.realTimeRecord.coordinate.lat,
									vehicule.realTimeRecord.coordinate.lng,
									18
								)
								.subscribe((adress) => {
									vehicule.realTimeRecord.geocoding = this.getGeocoding(adress.address);
									vehicule.realTimeRecord.geocodingDetails = adress.display_name;
									vehicule.realTimeRecord.vehicule = vehicule;
								});
						},
						(err) => {}
					);

					setInterval(() => {
						this.real.getRealTimeRecord(vehicule.idDevice).subscribe(
							(x) => {
								vehicule.realTimeRecord = x;
								vehicule.realTimeRecord.vehicule = new RealTimeRecord();

								this.geocodingService
									.inverseGeoconding(
										vehicule.realTimeRecord.coordinate.lat,
										vehicule.realTimeRecord.coordinate.lng,
										18
									)
									.subscribe((adress) => {
										vehicule.realTimeRecord.geocoding = this.getGeocoding(adress.address);
										vehicule.realTimeRecord.geocodingDetails = adress.display_name;
										vehicule.realTimeRecord.vehicule = vehicule;
									});
							},
							(err) => {}
						);

						//this.reCalculeRealTimeRecord();
					}, 30000);
				});
			});
		});
	}

	getGeocoding(address: any): string {
		let geocoding: string = null;
		if (address) {
			if (address.road != null) {
				geocoding = address.road;
			}
			if (address.neighbourhood != null) {
				geocoding = geocoding ? geocoding + ' ' + address.neighbourhood : address.neighbourhood;
			}
			if (address.city != null) {
				geocoding = geocoding ? geocoding + ' (' + address.city + ')' : address.city;
			}
			if (geocoding == null) {
				geocoding = 'chargement..';
			}
		}
		return geocoding;
	}

	voirSurCarte(vehicule) {
		//console.log(vehicule.realTimeRecord.coordinate);
		this.menuclose();

		let view = this.nav.getActive();
		if (view.component.name != 'Historical') {
			this.nav.setRoot(Historical);
		}
		this.mapService.map.setView(vehicule.realTimeRecord.coordinate, 15);
	}

	voirHistorique(group, vehicule, i, i2) {
		let selectedV = {
			group: group.idGroupe,
			selectedDeviceId: vehicule.idDevice,
			indexGroup: i,
			indexVehicule: i2
		};
		this.menuclose();

		let view = this.nav.getActive();

		if (view.component.name != 'HistoricalForm') {
			this.nav.push(HistoricalForm, { group: selectedV });

			// console.log("inside if");
		}
		//console.log("outside if");
		this.events.publish('showResult', selectedV);
	}

	voirinfo(group, vehicule, i, i2) {
		let selectedV = { group: group, vehicule: vehicule, indexGroup: i, indexVehicule: i2 };
		this.menuclose();

		let view = this.nav.getActive();

		if (view.component.name != 'InfoTrackerPage') {
			this.nav.push(InfoTrackerPage, { group: selectedV });

			// console.log("inside if");
		}
		this.events.publish('showinfo', selectedV);
	}

	carStatus(s): string {
		if (s.realTimeRecordStatus == 'VALID') {
			if (s.ignition == true) {
				if (s.speed > 0) {
					return 'green';
				} else {
					return 'blue';
				}
			} else {
				if (s.speed == 0) {
					return 'orange';
				} else {
					return 'red';
				}
			}
		} else {
			return 'red';
		}
	}

	speedCheck(s: number): boolean {
		if (s > 119) {
			return true;
		}
		return false;
	}

	hide() {
		this.hideMe = !this.hideMe;
		this.visibleV = !this.visibleV;
	}

	hideGroup() {
		this.hideGroupi = !this.hideGroupi;
		this.visibleG = !this.visibleG;
		this.data = this.groups;
		//console.log(this.visibleG);
	}

	toggleGroup(group) {
		console.log(this.groups[group].vehicules);
		//console.log(this.groups[group].vehicules.open);

		this.groups[group].vehicules.open = !this.groups[group].vehicules.open;
	}

	getItems(ev: any) {
		// Reset items back to all of the items
		//this.groups=this.data;
		this.generateGroups();
		this.generateGroups2();

		// set val to the value of the searchbar
		let val = ev.target.value;

		// if the value is an empty string don't filter the items
		if (val && val.trim() != '') {
			this.data = this.data.filter((group) => {
				this.searchWord = val;
				console.log(val);
				console.log(this.data);
				//this.groups = this.data;
				return group.nom.toLowerCase().indexOf(val.toLowerCase()) > -1;
			});
		}
	}

	goToHistoricalForm() {
		this.menuclose();
		this.nav.setRoot(HistoricalForm);
	}
	goToDashboard(){
		this.menuclose();
		this.nav.setRoot(DashboardPage);
	}
	generateGroups() {
		this.data = this.groups;
		return this.data;
	}

	generateGroups2() {
		this.data;

		//console.log(this.data);
	}

	// fermer menu
	menuclose() {
		this.menuCtrl.close();
		this.listhide = true;
	}
	//list getion de donnée
	hidelist() {
		this.listhide = !this.listhide;
	}
	//navigation to gestion Poi
	GotoGestpoi() {
		this.tempsreelopened = false;
		this.nav.push(GestPoi);
		this.menuclose();
	}
	GotoGestchauf() {
		this.tempsreelopened = false;
		this.nav.push(DriverComponent);
		this.menuclose();
	}
	//navigation to  temps reel et historique
	GotoTempsRealandHistorique() {
		if (!this.tempsreelopened) {
			this._app.getRootNav().setRoot(Historical);
		}
		this.menuclose();
		this.tempsreelopened = true;
	}
	//navigation to gestion de vehicule
	GoToGestVehi() {
		this.tempsreelopened = false;
		this.nav.push(Vehicules);
		this.menuclose();
	}
	//verification d'authentification
	checkPreviousAuthorization(): void {
		let toast = this.toastController.create({
			message: 'Session expirée!',
			duration: 4000
		});

		if (!JSON.parse(localStorage.getItem('currentuser'))) {
			this.rootPage = HomePage;
			this.isSignIn = true;
		} else {
			this.real.getGroupMini().subscribe(
				(y) => {
					this.nav.setRoot(Historical);
				},
				(err) => {
					toast.present();
					this.rootPage = HomePage;
				}
			);
			this.isSignIn = true;
		}
	}
	//alert quitter l'app
	showAlert() {
		this.alert = this.alertCtrl.create({
			title: 'Attention',
			message: 'Voulez vous vraiment quitter ?',
			buttons: [
				{
					text: 'Cancel',
					role: 'cancel',
					handler: () => {}
				},
				{
					text: 'Quitter',
					handler: () => {
						this.platform.exitApp();
					}
				}
			]
		});
		this.alert.present();
	}
	//navigation groupe"gestion de donnee"
	GoToGestGroup() {
		this.tempsreelopened = false;
		this.nav.push(Groupes);
		this.menuclose();
	}
	//alert deconnexion
	logoutconfirm() {
		this.menuclose();
		let actionSheet = this.actionSheetCtrl.create({
			title: 'Souhaitez-vous vraiment vous déconnecter?',
			buttons: [
				{
					text: 'Annuler',
					role: 'cancel',
					handler: () => {}
				},
				{
					text: 'Déconnexion',
					cssClass: 'Logout',
					handler: () => {
						this.logout();
					}
				}
			]
		});
		actionSheet.present();
	}
	//deconnexion
	logout(): void {
		localStorage.removeItem('currentuser');
		this._app.getRootNav().setRoot(HomePage);
	}

	toggleLevel1(idx) {
		if (this.isLevel1Shown(idx)) {
			this.showLevel1 = null;
		} else {
			this.showLevel1 = idx;
		}
		this.groups[idx].vehicules.open = !this.groups[idx].vehicules.open;
	}

	/*
    toggleLevel1(idx,f:string) {
    if (this.isLevel1Shown(idx)) {
      this.showLevel1 = null;
    } else {
      this.showLevel1 = idx;
  
    }
   // console.log(this.pages[idx].sub);
    //console.log(this.pages[idx].sub.open);
    this.pages[idx].sub.open = !this.pages[idx].sub.open;
    //this.nav.push(PathsList);
    this.Call_function(f);
  };*/
	toggleLevel2(id1, id2) {
		//this.optionsIsShown = !this.optionsIsShown ;
		this.groups[id1].vehicules[id2].open = !this.groups[id1].vehicules[id2].open;

		//console.log( this.groups[id1].vehicules[id2].open);
	}

	isLevel1Shown(idx) {
		return this.showLevel1 === idx;
	}

	isLevel2Shown(idx) {
		return this.showLevel2 === idx;
	}

	Call_function(f: string) {
		this.events.publish(f);
	}

	goToRealTime() {
		let view = this.nav.getActive();
		if (view.component.name != 'Historical') {
			this.nav.setRoot(Historical);
		}

		//prints out component name as string
		//console.log(view.component.name);
		this.hideGroup();
		//  this.menuclose();
	}

	//alert lancement Moteur
	AlertMoteur(deviceId) {
		// this.show = !this.show;
		if (!this.engine) {
			let alert = this.alertCtrl.create({
				title: 'Attention',
				message: 'Êtes-vous sûr ?',
				buttons: [
					{
						text: 'Annuler',
						role: 'cancel',
						handler: () => {}
					},
					{
						text: 'Arrêter',
						handler: () => {
							// this.startEngine(deviceId);
						}
					}
				]
			});
			alert.present();
		} else {
			let alert = this.alertCtrl.create({
				title: 'Attention',
				message: 'Êtes-vous sûr ?',
				buttons: [
					{
						text: 'Annuler',
						role: 'cancel',
						handler: () => {}
					},
					{
						text: 'Démarrer',
						handler: () => {
							// this.startEngine(deviceId);
						}
					}
				]
			});
			alert.present();
		}
	}

	//start moteur
	/* startEngine(deviceId) {
     this.realTimeService.startEngine(deviceId).subscribe(cmdSended => {
       alert("commande Lancement moteur envoyé !");
     });
   }*/

	//end
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts